import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import {
    DayPanel,
    RangePanel,
    WeekPanel,
    MonthPanel,
    DatePicker,
    Form,
    FormItem,
    Icon,
    QuickPanel
} from '@jd/jmtd';
import {
    formatDate,
    addDate,
    inRange,
    parseDate,
    getEndOfWeek,
    getWeekNumber,
    getEndOfMonth,
    diffInDay
} from '@jd/jmtd-tools/es/date';
import { FormGroup } from '@jd/jmtd-pro';
import { findYOY, Lunar, toString } from '@jd/jmtd-tools/es/lunar';
import { bubble } from '@jd/jmtd-tools/es/element';
import { findFirst } from '@jd/jmtd-tools/es/generator';

function getNewDate() {
    return new Date()
}

const yesterday = formatDate(addDate(getNewDate(), -1, 'day'), 'YYYY-MM-DD');
const newLastYear = addDate(getNewDate(), -1, 'year');
const completeWeek = formatDate(addDate(getEndOfWeek(getNewDate()), '-7', 'day'), 'YYYY-MM-DD');
const completeMonth = formatDate(addDate(getEndOfMonth(getNewDate()), '-1', 'month'), 'YYYY-MM-DD');
const defaultOfflineTime = {
    type: 'day',
    value: yesterday
};
const historyDefaultPickerValue = [newLastYear.getFullYear(), newLastYear.getMonth() + 1];
const storage = JSON.parse(sessionStorage.getItem('traffic_trafficOverview_session'));

const $$updateOfflineTime = Symbol('更新实时');
const $$updateCompareTime = Symbol('更新对比');

class ComboTimePicker extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.componentDidUpdate();
    }

    componentDidUpdate() {
        // 如果包裹在card中，为card-header添加一个独特的class控制，用于扩展高度
        const cardHeader = findFirst(bubble(this.placeholder), el =>
            (el.classList ? el.classList.contains('jmtd-card-header') : false));
        if (cardHeader) {
            cardHeader.classList.add('jmtp-ge-realtime-compare-time-group-header');
        }
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    render() {
        const {
            props: {
                value: {
                    compareTime,
                    offlineTime
                },
                dispatch,
                comparePanels,
                offlineWidth,
                compareWidth
            }
        } = this;

        return (
            <>
                <Form inline>
                    <FormItem label='时间'>
                        <DatePicker
                            width={offlineWidth}
                            icon={
                                <Icon className='jmti-calendar' />
                            }
                            placement='right'
                            panels={
                                [
                                    {
                                        ...DayPanel,
                                        isDateDisabled: date =>
                                            !inRange(
                                                date,
                                                parseDate('2019-12-01'),
                                                parseDate(yesterday)
                                            )
                                    },
                                    // {
                                    //     ...WeekPanel,
                                    //     isDateDisabled: date =>
                                    //         !inRange(
                                    //             date,
                                    //             parseDate('2019-12-01'),
                                    //             parseDate(completeWeek)
                                    //         )
                                    // },
                                    // {
                                    //     ...MonthPanel,
                                    //     isDateDisabled: date =>
                                    //         !inRange(
                                    //             date,
                                    //             parseDate('2019-12-01'),
                                    //             parseDate(completeMonth)
                                    //         )
                                    // },
                                    {
                                        ...RangePanel,
                                        isDateDisabled: date =>
                                            !inRange(
                                                date,
                                                parseDate('2020-01-01'),
                                                parseDate(yesterday)
                                            ),
                                        maxRange: 15
                                    }
                                ]
                            }
                            value={offlineTime}
                            onChange={v => {
                                dispatch($$updateOfflineTime, v);
                            }}
                        />
                    </FormItem>
                    <FormItem label='对比时间'>
                        <div clsTag={'h|keycount|yx_center_hzcp_1678258944439|10'}>
                            <DatePicker
                              icon={
                                  <Icon className='jmti-calendar' />
                              }
                              width={compareWidth}
                              placement='right'
                              panels={comparePanels}
                              value={compareTime}
                              onChange={v => {
                                  dispatch($$updateCompareTime, v);
                              }}

                            />
                        </div>
                    </FormItem>
                </Form>
                {/* 占位元素，用于获取父元素 */}
                <div
                    className='jmtp-ge-realtime-compare-time-group-placeholder'
                    ref={el => {
                        this.placeholder = el;
                    }}
                ></div>
            </>
        );
    }
}

ComboTimePicker.propTypes = {
    comparePanels: PropTypes.array.isRequired,
    dispatch: PropTypes.func,
    value: PropTypes.object.isRequired,
    offlineWidth: PropTypes.number,
    compareWidth: PropTypes.number
};

ComboTimePicker.defaultProps = {
    value: {
        compareTime: null,
        offlineTime: null
    },
    comparePanels: getPanel(defaultOfflineTime)
};

function getPanel(timeObj) {
    let panels = [
        {
            ...QuickPanel,
            label: '快捷对比',
            options: getQuickPanel(timeObj),
            // echo: v => v.label
        }
    ];
    // if (timeObj?.type === 'day') {
    //     panels = [].concat(
    //         panels,
    //         [
    //             {
    //                 ...DayPanel,
    //                 label: '最近30天',
    //                 isDateDisabled: date => !inRange(date, addDate(getNewDate(), -31, 'day'), addDate(getNewDate(), -1, 'day'))
    //             },
    //             {
    //                 ...DayPanel,
    //                 key: '2',
    //                 label: '2021-11',
    //                 defaultPickerValue: [2021, 11],
    //                 pickerConfig: {
    //                     disableBtn: {
    //                         prevMonth: true,
    //                         nextMonth: true,
    //                         prevYear: true,
    //                         nextYear: true
    //                     }
    //                 },
    //                 isDateDisabled: date => !inRange(date, parseDate('2021-11-01'), parseDate('2021-11-30'))
    //             },
    //             {
    //                 ...DayPanel,
    //                 key: '3',
    //                 label: '2021-06',
    //                 defaultPickerValue: [2021, 6],
    //                 pickerConfig: {
    //                     disableBtn: {
    //                         prevMonth: true,
    //                         nextMonth: true,
    //                         prevYear: true,
    //                         nextYear: true
    //                     }
    //                 },
    //                 isDateDisabled: date => !inRange(date, parseDate('2021-06-01'), parseDate('2021-06-30'))
    //             },
    //             {
    //                 ...DayPanel,
    //                 key: '4',
    //                 label: '历史数据',
    //                 defaultPickerValue: historyDefaultPickerValue,
    //                 pickerConfig: {
    //                     disableBtn: {
    //                         prevYear: true,
    //                         nextYear: true
    //                     }
    //                 },
    //                 isDateDisabled: date => !inRange(date, addDate(newLastYear, -9, 'day'), addDate(newLastYear, 6, 'day'))
    //             }
    //         ]
    //     );
    // }
    return panels;
}

function getQuickPanel(timeObj) {
    const nextQickPannel = [1, 2].map(n => {
        const text = getCompareTxt(timeObj, n);
        return {
            label: n === 1 ? '同比' : '环比',
            value: text,
            echo: text,
            type: n
        };
    });
    // if (timeObj?.type === 'day') {
    //     const yoy = findYOY(
    //         new Date(timeObj ?
    //             `${timeObj?.value} 00:00:00`
    //             :
    //             timeObj
    //         )
    //     );
    //     const lunarYoy = Lunar(yoy);
    //     nextQickPannel.push({
    //         label: '农历同比',
    //         echo: `${formatDate(yoy, 'YYYY-MM-DD')} ${toString(lunarYoy)}`,
    //         value: formatDate(yoy, 'YYYY-MM-DD'),
    //         type: 3
    //     });
    // }
    return nextQickPannel;
}

function getCompareTxt(date, type) {
    const { type: dateType, value: offlineDate } = date;
    let nextDateTxt = '';
    if (type !== 1) {
        if ((dateType === 'week' || dateType === 'month') && offlineDate[1] > 1) {
            nextDateTxt = `${offlineDate[0]}-${offlineDate[1] - 1}`;
        } else if (dateType === 'week') {
            const preWeekNumber = getWeekNumber(addDate(new Date(`${offlineDate[0]}-1-1`), -1, 'day'));
            nextDateTxt = `${offlineDate[0] - 1}-${preWeekNumber}`;
        } else if (dateType === 'month') {
            nextDateTxt = `${offlineDate[0] - 1}-12`;
        } else if (dateType === 'range') {
            const diffDay = diffInDay(new Date(offlineDate?.[1]), new Date(offlineDate?.[0]))
            nextDateTxt = `${formatDate(addDate(new Date(offlineDate[0]), -(diffDay + 1), 'day'), 'YYYY-MM-DD')}~${formatDate(addDate(new Date(offlineDate[1]), -(diffDay + 1), 'day'), 'YYYY-MM-DD')}`;
        } else {
            nextDateTxt = dateType === 'day' ? formatDate(addDate(new Date(offlineDate), -1, 'day'), 'YYYY-MM-DD') : `${formatDate(addDate(new Date(offlineDate[0]), -1, 'day'), 'YYYY-MM-DD')}~${formatDate(addDate(new Date(offlineDate[1]), -1, 'day'), 'YYYY-MM-DD')}`;
        }
    } else {
        // 同比
        if (dateType === 'week' || dateType === 'month') {
            nextDateTxt = `${offlineDate[0] - 1}-${offlineDate[1]}`;
        } else {
            nextDateTxt = dateType === 'day' ? formatDate(addDate(new Date(offlineDate), -1, 'year'), 'YYYY-MM-DD') : `${formatDate(addDate(new Date(offlineDate[0]), -1, 'year'), 'YYYY-MM-DD')}~${formatDate(addDate(new Date(offlineDate[1]), -1, 'year'), 'YYYY-MM-DD')}`;
        }
    }
    return nextDateTxt;
}

export default function trafficComboTimePicker({
    label,
    offlineWidth = 250,
    compareWidth = 180
} = {}) {
    return {
        component: ComboTimePicker,
        name: 'offlineTime',
        label,
        valueDestructuring({ offlineTime, compareTime: { type, value }}) {
            return {
                ...offlineTime,
                dateType: offlineTime?.type,
                date: offlineTime?.value,
                compareStartDate: type === 'quick' ? value?.value : value,
                compareEndDate: type === 'quick' ? value?.value : value,
                compareType: type === 'quick' ? value.type : '4'
            };
        },
        storageHandler({ props }) {
            return props.value;
        },
        async reducer({
            actionType, setState, dispatch, actionData, $$submit, changedByOther, getProps
        }) {

            if (actionType === FormGroup.INIT) {
                let props = {
                    value: {
                        offlineTime: defaultOfflineTime,
                        compareTime: {
                            type: 'quick',
                            value: getPanel(defaultOfflineTime)[0].options[0]
                        }
                    },
                    offlineWidth,
                    compareWidth,
                    dispatch
                }

                if (storage?.['form-group-offlineTime']) {
                    props = {
                        ...props,
                        value: storage?.['form-group-offlineTime']
                    }
                }

                // 缺失对比时间的storage的获取
                setState({
                    props
                })
            }

            let offlineTime;
            let compareTime;

            if (actionType === $$updateOfflineTime) {
                offlineTime = actionData;
            }

            if (actionType === $$updateCompareTime) {
                compareTime = actionData;
            }

            if (offlineTime || compareTime) {
                let toSet = {
                    value: {}
                }
                if (compareTime) {
                    toSet = {
                        value: {
                            offlineTime: getProps('offlineTime').value.offlineTime,
                            compareTime
                        }
                    }
                }
                if (offlineTime) {
                    const panels = getPanel(offlineTime);

                    toSet = {
                        ...toSet,
                        comparePanels: panels,
                        value: {
                            offlineTime,
                            compareTime: {
                                type: 'quick',
                                value: panels[0].options[0]
                            }
                        }
                    }
                }
                setState({
                    props: {
                        ...getProps('offlineTime'),
                        ...toSet
                    }
                })

                if ($$submit) {
                    dispatch($$submit);
                }
            } else if ($$submit && changedByOther) {
                dispatch($$submit);
            }
        }
    };
}
